import React from 'react';
import { Chip, ChipDelete } from '@mui/joy';

interface FilterChipProps {
  label: string;
  value: string;
  onClear?: () => void;
}

const FilterChip: React.FC<FilterChipProps> = ({ label, value, onClear }) => {
  return (
    <Chip
      variant="soft"
      size="sm"
      endDecorator={ onClear ? <ChipDelete onDelete={onClear} /> : null }
    >
      {label}: {value}
    </Chip>
  );
};

export default FilterChip; 